import React, { useState } from 'react';
import Home from '../pages/home-page';
import DetailPage from '../pages/detail-page';
import NotFound from '../pages/not-found-page';
import SigninCallback from '../auth-pages/signin-callback-page';
import SigninSilentCallback from '../auth-pages/silent-renew-page';

import redirectPage from '../pages/redirect-page';
import Header from '../components/layout/header';
import Banner from '../components/shared/banner';
import Footer from '../components/layout/footer';


import { withRouter, Switch, Route } from 'react-router-dom';
import CompanySelector from '../components/shared/company-selector';

function AppRoutes({ location }) {
  const [isUpdated, setIsUpdated] = useState(false);
  return (
    <>
      <CompanySelector onUpdate={(val) => setIsUpdated(val)} />
      {location.pathname !== '/signin-callback.html' ? <>
        <Header />
        <Banner />
      </> : null}
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/integration/:id" component={DetailPage} />
        <Route exact path="/signin-callback.html" component={SigninCallback} />
        <Route exact path="/silent-renew.html" component={SigninSilentCallback} />
        <Route exact path="/redirect-to-home" component={redirectPage} />
        <Route exact component={NotFound} />
      </Switch>
      {location.pathname !== '/signin-callback.html' ?
        <Footer />
        : null}
    </>
  );
}

export default withRouter(AppRoutes);